import { createContext, useEffect, useState, useRef } from "react";
import router from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
export var PreviousPathContext = /*#__PURE__*/createContext();
PreviousPathContext.displayName = "PreviousPathContext";
var ignorePath = ["login", "signup", "profiles", "account", "password_remind", "profile_pincode_reset", "restricted"];
export function PreviousPathProvider(_ref) {
  var children = _ref.children;
  var previousPath = useRef();

  var _useState = useState(),
      _path = _useState[0],
      setPath = _useState[1];

  useEffect(function () {
    var handler = function handler(url) {
      setPath(function (prev) {
        if (prev && !ignorePath.find(function (path) {
          return prev.match(new RegExp(path));
        })) {
          previousPath.current = prev;
        }

        return url;
      });
    };

    handler(router.asPath);
    router.events.on("routeChangeComplete", handler);
    return function () {
      router.events.off("routeChangeComplete", handler);
    };
  }, []);
  return /*#__PURE__*/_jsx(PreviousPathContext.Provider, {
    value: previousPath.current,
    children: children
  });
}